import "@elastic/eui/dist/eui_theme_light.css";
import "jquery-ui/themes/base/all.css";
import "./document-confluence.less";

import ReactDOM from "react-dom/client";
import axios from "axios";

import { EuiProvider } from "@elastic/eui";
import {
  BrowserRouter as Router,
} from "react-router-dom";

import App from "./App";

// Auth via cookie httpOnly : axios envoie le cookie sur toutes les requêtes
// cross-origin (CORS credentials côté back doit aussi être actif).
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <EuiProvider>
    <Router>
      <App />
    </Router>
  </EuiProvider>,
  
);
